export const ONBOARDING_CONTACT_TOKEN_HEADER = 'x-onboarding-contact-token';
